export class DNITriggers extends HTMLElement {
  constructor(dni_campaign_parameter_triggers) {
    super();
    this.dni_campaign_parameter_triggers = dni_campaign_parameter_triggers;
  }
  connectedCallback() {
    this.innerHTML = 
      `<label>DNI Trigger</label>
        <div>
          <div class="row">
            <span class="col-sm-6 no-gutters">Allow only certain parameters to trigger DNI events</span>
            <div class="col-sm-6"><button class="btn btn-outline-primary pull-left" id="dni-trigger-btn">Add DNI Trigger</button></div>
          </div>
          <div class="errors"></div>
          
        </div>
        <div class="dni_trigger_container"></div>`;

      this.dni_campaign_parameter_triggers.forEach((dni_campaign_parameter_trigger) => {
        let triggerForm = new DNITriggerForm(dni_campaign_parameter_trigger);
        this.querySelector('.dni_trigger_container').appendChild(triggerForm);
      })   
      if(this.dni_campaign_parameter_triggers.length > 0) {
        this.querySelector('#dni-trigger-btn').classList.add('hidden');
      }

      this.querySelector('#dni-trigger-btn').addEventListener('click', function(e) {
        e.preventDefault()
        this.querySelector('#dni-trigger-btn').classList.add('hidden');
        let triggerForm = new DNITriggerForm();
        this.querySelector('.dni_trigger_container').appendChild(triggerForm);
      }.bind(this))
  }
  validate() {
    let isValid = true;
    let errors = "";
    let trigger_values = [];
    let name_exists = true;
    // Validates name field
    this.querySelectorAll('.dni-trigger-parameter-name').forEach(elem => {
      if(!elem.value.trim()) {
        name_exists = false;
        elem.classList.add('error');
      }
    })
    if(name_exists == false) {
      errors += `<div class="alert alert-danger alert-dismissible" role="alert" style="margin-top:4px">
      <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
      <strong>Warning!</strong> Please provide a DNI Trigger name.
      </div>`;
      isValid = false;
    }
    //Validates duplicate name/value pairs
    this.querySelectorAll('.dni-trigger-row').forEach(elem => trigger_values.push(`${elem.querySelector('.dni-trigger-parameter-name').value}_${elem.querySelector('.dni-trigger-parameter-value').value}`));
    let duplicates = trigger_values.reduce(function(acc, el, i, arr) {
      if (arr.indexOf(el) !== i && acc.indexOf(el) < 0) acc.push(el); return acc;
    }, []);
    if(duplicates.length > 0) {
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <strong>Warning!</strong> DNI Trigger name/value pairings must be unique.
                  </div>`;
      isValid = false;
    }
    this.querySelector('.errors').innerHTML = errors;

    return isValid
  }
}

customElements.define('dni-triggers', DNITriggers)

class DNITriggerForm extends HTMLElement {
  constructor(dni_campaign_parameter_trigger = null) {
    super();
    this.dni_campaign_parameter_trigger = dni_campaign_parameter_trigger;
  }
  connectedCallback() {
    this.dni_trigger_container = this.closest(".dni_trigger_container");
    this.innerHTML = 
    `<style>
      .dni-trigger-row {
        margin-bottom: 20px;
        position: relative;
      }
    </style>
    <div class="row dni-trigger-row">
      <div class="col-md-5">
        <label>Name</label>
        <input type="text" class="form-control dni-trigger-parameter-name" placeholder="Required" value="${this.dni_campaign_parameter_trigger != null ? this.dni_campaign_parameter_trigger.url_parameter_name : ""}">
      </div>
      <div class="col-md-5">
        <label>Value</label>
        <input type="text" class="form-control dni-trigger-parameter-value" value="${this.dni_campaign_parameter_trigger != null && this.dni_campaign_parameter_trigger.url_parameter_value ? this.dni_campaign_parameter_trigger.url_parameter_value : ""}">
      </div>
      <div class="col-md-2 dni-url-add" style="line-height:30px;">
        <a class="remove_row"><span class="fa fa-minus"></span></a>
        <a class="add_row"><span class="fa fa-plus"></span></a>
      </div>
    </div>`;

    this.querySelector('.add_row').addEventListener('click', this.addRow.bind(this))
    this.querySelector('.remove_row').addEventListener('click', this.removeRow.bind(this))
  }
  addRow() {
    let triggerForm = new DNITriggerForm();
    this.dni_trigger_container.appendChild(triggerForm);
  }

  removeRow() {
    this.dni_trigger_container.removeChild(this)
    if(this.dni_trigger_container.child.length == 0) {
      document.querySelector('#dni-trigger-btn').classList.remove('hidden');
    }
  }

  getData() {
    return {
      dni_campaign_parameter_trigger_id: this.dni_campaign_parameter_trigger != null ? this.dni_campaign_parameter_trigger.dni_campaign_parameter_trigger_id : null,
      url_parameter_name: this.querySelector(".dni-trigger-parameter-name").value,
      url_parameter_value: this.noEmptyString(this.querySelector(".dni-trigger-parameter-value").value)
    }
  }

  noEmptyString(val) {
    return val && val.trim().length > 0 ? val.trim() : null;
  }
}

customElements.define('dni-trigger-form', DNITriggerForm)